import { render, staticRenderFns } from "./PerintahKerja.vue?vue&type=template&id=b1591704&"
import script from "./PerintahKerja.vue?vue&type=script&lang=js&"
export * from "./PerintahKerja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports